import Select from "./Select";
import "./Select.css";

const LabeledSelect = ({
  label,
  items = [],
  selectedItem = "",
  placeholder,
  name = "",
  onChange = () => {},
  disable = false,
  labelWidth = "auto",
  className = "",
}) => {
  return (
    <div className={`labeled-select-container ${className}`}>
      {label && (
        <label
          className="labeled-select-label App-text-large"
          style={{ width: labelWidth }}
        >
          {label}
        </label>
      )}
      <Select
        items={items}
        selectedItem={selectedItem}
        placeholder={placeholder}
        name={name}
        onChange={onChange}
        disable={disable}
      />
    </div>
  );
};

export default LabeledSelect;
